import { Box, Grid2 as Grid, Stack, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import { colors } from 'src/global/styles/colors';
import { ProjectInputs } from 'src/global/types/project.type';
import { useDeployment } from 'src/provider/DeploymentProvider';

import { AdminInput } from '../AdminTextField';
import { StepAccordion } from '../StepAccordion';
import { ReferralDiscount } from './ReferralDiscount';
import { TokenReward } from './TokenReward';

const ReferralProgram = ({
  defaultIsEnable,
  defaultIsDonationEnable,
  isDetail,
}: {
  defaultIsEnable?: boolean;
  defaultIsDonationEnable?: boolean;
  isDetail?: boolean;
}) => {
  const { hasDeployed } = useDeployment();
  const {
    control,
    formState: { errors },
  } = useFormContext<ProjectInputs>();

  return (
    <StepAccordion isError={!!errors.referral || !!errors.kols} index={5} title='Referral Program' open={false}>
      <Typography variant='body1' fontSize={'14px'} fontWeight={400} sx={{ color: 'white' }} paddingBottom={3}>
        Set up referral rewards, discount percentages, and fallback donation options when no referral code is used.
      </Typography>
      <Grid container columnSpacing={2}>
        <Grid size={12}>
          <Box width={'100%'}>
            <Typography paddingBottom={1} color={colors.neutral200} fontSize={'14px'} variant='h6'>
              Description
            </Typography>
            <Controller
              name='referral.rewardDescription'
              control={control}
              render={({ field }) => (
                <AdminInput
                  rows={5}
                  inputHeight='140px'
                  multiline
                  isError={!!errors?.referral?.rewardDescription}
                  errorMsg={errors.referral?.rewardDescription?.message}
                  placeholder={'Give a short description about the referral program...'}
                  readOnly={isDetail}
                  {...field}
                />
              )}
            />
          </Box>
        </Grid>
        <TokenReward
          isDisabled={isDetail}
          defaultIsDonationEnable={defaultIsDonationEnable}
          defaultIsEnable={defaultIsEnable}
        />
        <Grid size={12} marginTop={3}>
          <Stack direction='row' alignItems='center' width={'100%'} justifyContent={'space-between'}>
            <ReferralDiscount isDisabled={isDetail || hasDeployed} />
          </Stack>
        </Grid>
      </Grid>
    </StepAccordion>
  );
};

export default ReferralProgram;
